import OriginalRefundSource from "../../../calendar/OriginalRefundSource";
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import * as Yup from "yup";
import { Formik } from "formik";
import yupconfig from "../../../../yupconfig";
import moment from 'moment';
import "../../../../config";
import { InputField } from '../../../../component/form/Field';
import XeroRefundLineAllocation from '../../../../component/XeroRefundLineAllocation';
import { prepareXeroRefundValues } from '../../../../helpers/xeroRefundAllocation';
import appointmentApiController from '../../../../services/appointment.service';
import { TaxValueApi } from 'store/slices/taxSlice';
import { availableRefundPaymentMethods, buildAppointmentRefundValues, isRefundPaymentMethodReady, preselectedRefundPaymentMethod, refundPaymentMethodLabel, refundPaymentMethodConfirmation } from '../../../calendar/refundPaymentMethods';
import 'store/slices/clientinvoiceSlice';
import { ClientAppointmentListViewApi, refundPaymentStoreApi } from 'store/slices/appointmentSlice';
import 'store/slices/serviceSlice';
import 'component/Sweatalert2';
import customToast from 'component/Toastr';
import { ActiveBtnStateClientAppointments, OpenClientRefundSelection, OpenRefundInvoice, openPastInvoiceDrawer } from 'store/slices/clientappointmentinvoiceSlice';
import { useNavigate } from 'react-router';

const RefundFromInvoiceModalAppointments = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    useNavigate();
    const [loading, setLoading] = useState(false);
    const [OpenConfirmModal, setOpenConfirmModal] = useState(false);
    const auth = useSelector((state) => state.auth);
    void (auth.user);
    const isFilter = useSelector((state) => state.appointment.isClientAppointmentFilterStatus);
    const isOpenClientRefundSelection = useSelector((state) => state.clientpastinvoice.isOpenClientRefundSelection);
    const isRefundInvoiceData = useSelector((state) => state.clientpastinvoice.isRefundInvoiceData);
    const isGetTotalDepositAmount = useSelector((state) => state.clientpastinvoice.isGetTotalDepositAmount);
    useSelector(state => state.clientinvoice.isSaleCompletedData);
    useSelector(state => state.appointment.isDetailData);
    useSelector(state => state.appointment.isGetCancelledAppointmentData);
    const isActiveBtnState = useSelector((state) => state.clientpastinvoice.isActiveBtnStateClientAppointments);
    useSelector(state => state.clientpastinvoice.isStripeTokenClientAppointments);
    useSelector(state => state.appointment.isGetAppointmentcancelRefundStripe);
    const servicesname = isRefundInvoiceData && isRefundInvoiceData.service && isRefundInvoiceData.service.name ? isRefundInvoiceData.service.name : "";
    const staffName = isRefundInvoiceData && isRefundInvoiceData.staff && (isRefundInvoiceData.staff.first_name && isRefundInvoiceData.staff.last_name) ? isRefundInvoiceData.staff.first_name + " " + isRefundInvoiceData.staff.last_name : "";
    const appoitmentTime = isRefundInvoiceData && isRefundInvoiceData.start_time && isRefundInvoiceData.end_time ? moment(isRefundInvoiceData.start_time, "HH:mm:ss").format("hh:mm A") + " - " + moment(isRefundInvoiceData.end_time, "HH:mm:ss").format("hh:mm A") : "";
    const cost = isRefundInvoiceData && isRefundInvoiceData.cost ? isRefundInvoiceData.cost : "";
    void (isRefundInvoiceData && isRefundInvoiceData.client && isRefundInvoiceData.client.first_name && isRefundInvoiceData.client.last_name ? isRefundInvoiceData.client.first_name + " " + isRefundInvoiceData.client.last_name : "");
    const invoicedate = isRefundInvoiceData && isRefundInvoiceData.sale && isRefundInvoiceData.sale.invoicedate ? moment(isRefundInvoiceData.sale.invoicedate).format("DD/MM/YYYY") : "";
    const InvoiceTax = useSelector((state) => state.tax.isTaxValue);
    let taxPercentage = InvoiceTax && InvoiceTax.percentage;
    void (taxPercentage ? cost / taxPercentage : "");

    useEffect(() => {
        dispatch(TaxValueApi());
    }, []);


    const initialValues = {
        id: "",
        sale_id: "",
        client_id: "",
        total_deposit_refund: "",
        xero_line_allocations: [],
        totaldeposit: "",
        deposit_payment_by: "",
        stripe_payment_method_id: "",
        stripe_token_id: "",
        total_cost: "",
        service_id: "",
        status: ""
    };

    const validationSchema = Yup.object().shape({
        total_deposit_refund: Yup.number()
            .required(t("Total deposit is required"))
            .typeError(t("Total deposit must be a number"))
            .moreThan(0, t("Total deposit must be greater than 0"))
            .max(isGetTotalDepositAmount && parseFloat(isGetTotalDepositAmount), t("Total deposit cannot exceed the amount paid"))
            .test('is-not-negative', t("Negative values are not allowed"), value => value >= 0.0)
    });
    yupconfig();

    const handleAppointmentRefund = async (values, { setErrors, setStatus, setSubmitting }) => {
        setLoading(true);
        try {
            const refundValues = await prepareXeroRefundValues(buildAppointmentRefundValues(isRefundInvoiceData, values), appointmentApiController);
            const action = await dispatch(refundPaymentStoreApi(refundValues));
            if (action.meta.requestStatus !== "fulfilled") {
                const response = action.payload && action.payload.message;
                const errors = response && response.errors;
                const message = typeof response === "string" ? response : response && response.message;
                if (errors) setErrors(errors);
                setStatus({ success: false });
                customToast.error(message || t("Refund failed"));
                return;
            }
            setStatus({ success: true });
            dispatch(ClientAppointmentListViewApi({client_id: values.client_id,page_name:"client_appointment",isFilter: isFilter }));
            dispatch(openPastInvoiceDrawer(""));
            dispatch(OpenRefundInvoice(""));
            dispatch(OpenClientRefundSelection(""));
            customToast.success(`${t("Refund Complete")}`);
        } catch (err) {
            setErrors({ refund: err.message });
            setStatus({ success: false });
            customToast.error(err.message || t("Refund failed"));
        } finally {
            setSubmitting(false);
            setLoading(false);
        }
    }


    return (
        <div>
            <div className={isOpenClientRefundSelection === "open" ? "modal fade show" : "modal fade"} id="add-emailverification" tabIndex="-1" aria-labelledby="addemailverificationModalLabel" style={{ display: isOpenClientRefundSelection === "open" ? "block" : "none" }}>
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleAppointmentRefund}>
                    {(formik) => {



                        useEffect(() => {
                            if (isRefundInvoiceData) {
                                formik.setFieldValue("refund_source", "");
                                formik.setFieldValue("deposit_payment_by", preselectedRefundPaymentMethod(isRefundInvoiceData));
                                formik.setFieldValue("id", isRefundInvoiceData && isRefundInvoiceData.id ? isRefundInvoiceData.id : "");
                                formik.setFieldValue("client_id", isRefundInvoiceData && isRefundInvoiceData.client_id ? isRefundInvoiceData.client_id : "");
                                formik.setFieldValue("sale_id", isRefundInvoiceData && isRefundInvoiceData.sale && isRefundInvoiceData.sale.id ? isRefundInvoiceData.sale.id : "");
                                formik.setFieldValue("service_id", isRefundInvoiceData && isRefundInvoiceData.service && isRefundInvoiceData.service.id ? isRefundInvoiceData.service.id : "");
                                formik.setFieldValue("total_cost", isRefundInvoiceData && isRefundInvoiceData.cost ? isRefundInvoiceData.cost : "");
                            }
                        }, [isRefundInvoiceData])

                        useEffect(() => {
                            if (isGetTotalDepositAmount) {
                                formik.setFieldValue("total_deposit_refund", isGetTotalDepositAmount ? isGetTotalDepositAmount : "");
                                formik.setFieldValue("totaldeposit", isGetTotalDepositAmount ? isGetTotalDepositAmount : "");
                            }
                        }, [isGetTotalDepositAmount])

                        return (
                            <div className="modal-dialog modal-lg modal-dialog-centered ac-setup">
                                <div className="modal-content ">
                                    <div className="modal-body pb-0">
                                        <form noValidate onSubmit={formik.handleSubmit}>
                                            <div className="p-3">
                                                <h5 className="mb-3 fw-semibold text-dark">{t("Issue Refund")}</h5>
                                                <div className="input-field">
                                                    <div className="row gx-2">
                                                        <div className="col-md-3">
                                                            <h6 className="fw-semibold mb-1">Item</h6>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <h6 className="fw-semibold mb-1">Quantity</h6>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <h6 className="fw-semibold mb-1">Amount Paid</h6>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <h6 className="fw-semibold mb-1">Refund</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="input-field">
                                                    <div className="row gx-2">
                                                        <div className="col-md-3">
                                                            <h6 className="mb-1">{`${servicesname}`}</h6>
                                                            <p className="mb-0">{`With ${staffName} on ${invoicedate} from ${appoitmentTime}`}</p>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <h6 className="mb-1">1</h6>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <h6 className="mb-1">${formik.values.totaldeposit ? formik.values.totaldeposit : ""}</h6>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <InputField type="text" name="total_deposit_refund" value={formik.values.total_deposit_refund} controlId="AppointmentRefundInvoice-deposit" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <OriginalRefundSource detail={isRefundInvoiceData} formik={formik} />
                                                <XeroRefundLineAllocation active={isOpenClientRefundSelection === "open"} formik={formik} />
                                                {isRefundInvoiceData && isRefundInvoiceData.addonservices && isRefundInvoiceData.addonservices.length > 0 ? (
                                                    <div className="input-field">
                                                        <div className="row gx-2">
                                                            <label htmlFor="">Add On Services</label>
                                                            {isRefundInvoiceData.addonservices.map((item, i) => {
                                                                const addonServiceName = item && item.service && item.service.name;
                                                                let addonstaffFullName = item && item.staff && (item.staff.first_name && item.staff.last_name) ? item.staff.first_name + " " + item.staff.last_name : "";
                                                                let addonserviceStartTimes = item && item.start_time ? item.start_time : "";
                                                                let addonserviceStart = moment(addonserviceStartTimes, "HH:mm:ss").format("hh:mm A");
                                                                let addonserviceEndsTimes = item && item.end_time ? item.end_time : "";
                                                                let addonserviceEnds = moment(addonserviceEndsTimes, "HH:mm:ss").format("hh:mm A");
                                                                let addonappointmentTime = item && item.dateof ? moment(item.dateof, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
                                                                void (item && item.cost ? item.cost : "");

                                                                return (
                                                                    <div className='col-12' key={i}>
                                                                        <h6 className="mb-1">{`${addonServiceName ? addonServiceName : ""}`}</h6>
                                                                        <p className="mb-0">With {addonstaffFullName} on {addonappointmentTime} from {addonserviceStart + " - " + addonserviceEnds}</p>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                ) : ""}
                                                {isRefundInvoiceData && isRefundInvoiceData.addanotherservices && isRefundInvoiceData.addanotherservices.length > 0 ? (
                                                    <div className="input-field">
                                                        <div className="row gx-2">
                                                            <label htmlFor="">Add another Services</label>
                                                            {isRefundInvoiceData.addanotherservices.map((item, i) => {
                                                                const addanotherServiceName = item && item.service && item.service.name;
                                                                let addanotherstaffFullName = item && item.staff && (item.staff.first_name && item.staff.last_name) ? item.staff.first_name + " " + item.staff.last_name : "";
                                                                let addanotherserviceStartTimes = item && item.start_time ? item.start_time : "";
                                                                let addanotherserviceStart = moment(addanotherserviceStartTimes, "HH:mm:ss").format("hh:mm A");
                                                                let addanotherserviceEndsTimes = item && item.end_time ? item.end_time : "";
                                                                let addanotherserviceEnds = moment(addanotherserviceEndsTimes, "HH:mm:ss").format("hh:mm A");
                                                                let addanotherappointmentTime = item && item.dateof ? moment(item.dateof, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
                                                                void (item && item.cost ? item.cost : "");

                                                                return (
                                                                    <div className='col-12' key={i}>
                                                                        <h6 className="mb-1">{addanotherServiceName ? addanotherServiceName : ""}</h6>
                                                                        <p className="mb-0">With {addanotherstaffFullName} on {addanotherappointmentTime} from {addanotherserviceStart + " - " + addanotherserviceEnds}</p>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                ) : ""}
                                                {/* {currentUser && currentUser.salon && currentUser.salon.tax && currentUser.salon.tax.name === "Non-GST" ? "" : (
                                                    <div className="">
                                                        <div className="row gx-2">
                                                            <div className="col-md-3">
                                                                <h6 className="mb-1"></h6>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <h6 className="mb-1"></h6>
                                                            </div>
                                                            <div className="col-md-3 border-bottom-grays">
                                                                <h6 className="mb-0">Includes GST of</h6>
                                                            </div>
                                                            <div className="col-md-3 border-bottom-grays">
                                                                <h6 className="mb-0">${tax ? parseFloat(tax).toFixed(2) : "0"}</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )} */}
                                                <div className="">
                                                    <div className="row gx-2">
                                                        <div className="col-md-3">
                                                            <h6 className="mb-1"></h6>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <h6 className="mb-1"></h6>
                                                        </div>
                                                        <div className="col-md-3 border-bottom-grays">
                                                            <h5 className="fw-semibold mb-1">Total AUD</h5>
                                                        </div>
                                                        <div className="col-md-3 border-bottom-grays">
                                                            <h5 className='mb-0'>${formik.values.total_deposit_refund}</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                                {OpenConfirmModal && (
                                                    <>
                                                        <div className={OpenConfirmModal ? "modal fade show" : "modal fade"} id="add-emailverification" tabIndex="-1" aria-labelledby="addemailverificationModalLabel" style={{ display: OpenConfirmModal ? "block" : "none" }}>
                                                            <div className="modal-dialog modal-dialog-centered">
                                                                <div className="modal-content">
                                                                    <div className="modal-body pb-0">
                                                                        <div className="p-3">
                                                                            <h5 className="mb-3 fw-semibold text-dark">{t("Confirm Payment")}</h5>
                                                                            <p className="fw-semibold mb-2">{t(`Are you sure you want to refund this payment ${refundPaymentMethodConfirmation(isActiveBtnState)} ?`)}</p>
                                                                        </div>
                                                                        <div className="row mt-3 bg-cream p-4 justify-content-center">
                                                                            <div className="col-6">
                                                                                <button className="preview btn me-1 cursor-pointer btn-preview w-100" type="button" onClick={() => {
                                                                                    setOpenConfirmModal(false);
                                                                                }}>
                                                                                    {t("Cancel")}
                                                                                </button>
                                                                            </div>
                                                                            <div className="col-6">
                                                                                <button className="btn btn-primary w-100" onClick={() => {
                                                                                    formik.setFieldValue("deposit_payment_by", isActiveBtnState);
                                                                                    setOpenConfirmModal(false);
                                                                                }} type="button">
                                                                                    {t("Confirm")}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {OpenConfirmModal && <div className="modal-backdrop show"></div>}
                                                    </>
                                                )}
                                                {/* Refund Type Button */}
                                                <div className="mb-3">
                                                    <h6 className="fw-semibold mb-3">Choose Refund Payment Type </h6>
                                                    <div className="row justify-content-center">
                                                        {availableRefundPaymentMethods(isRefundInvoiceData, formik.values.refund_source).map(method => (
                                                            <div className="col-6 col-sm-3 mb-3" key={method}>
                                                                <button type="button" className={`btn ${formik.values.deposit_payment_by === method ? "btn-dark" : "btn-light-gray"} w-100`} onClick={() => {
                                                                    setOpenConfirmModal(true);
                                                                    dispatch(ActiveBtnStateClientAppointments(method));
                                                                }}>{t(refundPaymentMethodLabel(method))}</button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3 bg-cream p-4 justify-content-center">
                                                <div className="col-6">
                                                    <button className="preview btn me-1 cursor-pointer btn-preview w-100" type='button' onClick={() => {
                                                        dispatch(OpenClientRefundSelection(""));
                                                    }}>
                                                        {t("Cancel")}
                                                    </button>
                                                </div>
                                                <div className="col-6">
                                                    <button type="submit" className="btn btn-primary w-100" disabled={loading || !isRefundPaymentMethodReady(formik.values.deposit_payment_by)}>
                                                        {loading && <span className="spinner-border spinner-border-sm"></span>}
                                                        {t("Refund Payments")}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        )
                    }}
                </Formik>
            </div>
            {isOpenClientRefundSelection === "open" && <div className="modal-backdrop show"></div>}
        </div>
    )
}

export default RefundFromInvoiceModalAppointments;
